// extracted by mini-css-extract-plugin
module.exports = {"aboveImage":"css_aboveImage__2M1VT"};